// Voeg hier echte Google-reviews toe zodra ze binnenkomen. De reviewsectie
// verschijnt automatisch op de website zodra deze lijst minimaal één review bevat.
// Voorbeeld:
// { name: "Peter uit Drunen", rating: 5, text: "Stipt op tijd en een prettige rit.", date: "oktober 2026" }
export const REVIEWS = [];

// Plak hier de "Schrijf een review"-link vanuit het Google Bedrijfsprofiel
// (Google Business Profile → "Ask for reviews") zodra het profiel live is.
export const GOOGLE_REVIEW_URL = "";
